import React from 'react'
import { Alert, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import Template from 'components/Template'
import FlexContainer from 'components/FlexContainer'

const Checkpoint = () => {
  const { t } = useTranslation()

  return (
    <Template withAnimationType="fadeIn">
      <Row>
        <Col className="mx-auto" md={12} xl={12} sm={12} xs={12}>
          <FlexContainer>
            <Alert variant="warning" className="text-center">
              {t('MAILS.checkpoint')}
            </Alert>
          </FlexContainer>
        </Col>
      </Row>
    </Template>
  )
}

export default Checkpoint
